import React from "react";
import { useParams } from "react-router-dom";
import Complaints from "./Complaints";
import { CHEFS_FARM, GROWY } from "../../../../constants/CompanyConstants";

const ComplaintsWrapper = () => {
  const { companyType } = useParams();

  const getCompanyConfig = (type) => {
    switch (type) {
      case "chefs-farm":
        return {
          companyFilter: CHEFS_FARM,
          title: "complaints_chefs_farm",
        };
      case "growy":
        return {
          companyFilter: GROWY,
          title: "complaints_growy",
        };
      default:
        return {
          companyFilter: "All",
          title: "all_complaints",
        };
    }
  };

  const config = getCompanyConfig(companyType);

  return <Complaints {...config} />;
};

export default ComplaintsWrapper;
